export const dropdownInArticle = () => {
    var dropHeaderBlockArray = document.getElementsByClassName("drop-area-header");
    Array.from(dropHeaderBlockArray).forEach((element) => {
        element.addEventListener("click", (e) => {
            element.classList.toggle("dropped");
        });
    });
};